import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router';

class CheckIsLogin extends Component {

  render () {
    if (this.props.islogin === false) {
      return (<Redirect to="/" />);
  }
    return (
      <div></div>
    );
  }
}  
const mapStateToProps = state => ({
  state: state,
  islogin: state.gettocken.islogin,
});

export default connect(mapStateToProps)(CheckIsLogin );